import { type FC } from 'react';

interface Props {
  value: string;
}

export const CellWithTitle: FC<Props> = ({ value }) => {
  return <span title={value}>{value}</span>;
};
